export class PatientAccount {
    first_name: string;
    middle_name: string;
    last_name: string;

    relation: string;
    gender: string;
    date_of_birth: Date;
    country_id: string;
    state_name: string;
    city: string;
    address_line_1: string;
    address_line_2: string;
    zip_code: string;
    primary_contact_number: string;
    secondary_contact_number: string;
    account_status: string;
    avatar_url: string;
    auto_renewal: boolean;
    accepted_terms_id: number;
    is_agreed_terms: 1;
    medical_record_number?: number;
    country?: {
        country_name: string;
    };
    identification_url?: string;
    identification_type?: string;
    user_patient?: {
        users: {
            e_email: string;
        };
    };
    consultation?: {
        id: number;
        consultation_request_number: string;
        consultation_date: Date;
        consultation_status: string;
        created_at: Date;
        consultation_type_id: number;
        condition_description?: string
    }[];
}

export interface MembershipModel {
    user_guid: string;
    first_name: string;
    middle_name: string;
    last_name: string;
    file: File;
    relation: string;
    gender: string;
    date_of_birth: string;
    country_id: string;
    state_name: string;
    state_id: number;
    city: string;
    address_line_1: string;
    address_line_2: string;
    zip_code: string;
    primary_contact_number: string;
    secondary_contact_number: string;
    identification_type: string;
    identification: File;
}

export class PatientUpdate {
    patient_guid: string = "";
    first_name: string = "";
    middle_name: string = "";
    last_name: string = "";
    date_of_birth: string = null;
    date_of_birth_date: Date = null;
    address_line_1: string = "";
    address_line_2: string = "";
    country_id: number = null;
    state_name: string = "";
    state_id: string = "";
    gender: string = "";
    zip_code: string = "";
    city: string = "";
    primary_contact_number: string = "";
    secondary_contact_number: string = "";
    file: File = null;
    identification_type: string = null;
    identification: File = null;
    identification_url: string = "";
    avatar_url: string = "";
    max_date: Date = new Date();
    selectedState: { id: string, name: string } = null;
    phone_code: string = "";
    primary_contact_ten_digits: string = "";
    secondary_contact_ten_digits: string = "";
}

export interface MembershipModelFormChecker {
    user_guid: boolean;
    first_name: boolean;
    middle_name: boolean;
    last_name: boolean;
    file: boolean;
    relation: boolean;
    gender: boolean;
    date_of_birth: boolean;
    country_id: boolean;
    state_name: boolean;
    state_id: boolean;
    city: boolean;
    address_line_1: boolean;
    address_line_2: boolean;
    zip_code: boolean;
    primary_contact_number: boolean;
    secondary_contact_number: boolean;
    identification_type: boolean;
    identification: boolean;
}

export interface getPatientQuery {
    date: string;
}
export interface getPatientQueryview {
    user_guid: string;
    date: string;
    consultation_type_id?: number;
    specialty_id?: number;
}
export class Patientspastconsultations {
    id: number;
    patient_guid: string;
    consultation_id: number;
    name: string;
    age: string;
    address?: string;
    country?: string;
    contact?: string;
    specialty?: string[];
    opinion_type: string;
    priority_type?: string;
    doctor_name?: string[];
    email?: string;
    consultation_date: Date;
    req_no: string;
}
export class raw_patient_pastconsultation {
    patient_guid: string;
    id: number;
    consultation_date: Date;
    consultation_request_number: string;
    accounts: {
        first_name: string;
        middle_name: string;
        last_name: string;
        date_of_birth?: Date;
        address_line_1?: string;
        address_line_2?: string;
        primary_contact_number?: string;
        country: {
            country_name: string;
        };
        user_patient?: {
            user_guid: string;
            users: {
                e_email: string;
            };
        };
    };
    p_consultation_appointment: {
        specialty_id: number;
        user_guid: string;
        d_specialty_type: {
            specialty_name: string;
        };
        egd_users?: {
            d_email: string;
            first_name: string;
            middle_name: string;
            last_name: string;
        };
    }[];
    priority_type: {
        consultation_name: string;
        priority_type: string;
        transaction_type: string;
    };
}
